import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';

import Routes from 'Routes';
import { WebinarType } from 'models/webinars';

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #17181E;
  background-color: #FFF;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
`;

const NameContainer = styled.div`
  flex: 1 0 auto;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 22px;
  color: #17181E;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const DateTimeContainer = styled.div`
  flex: 1 0 auto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 13px;
  color: #999;
  margin-top: 10px;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const WebinarSearchResultItem = ({
  type,
  name,
  startAt,
  endAt,
}) => {
  switch (type) {
    case WebinarType.Live: {
      return (
        <StyledLink to={Routes.webinar}>
          <NameContainer>
            { name }
          </NameContainer>
          <DateTimeContainer>
            { `${startAt?.format('HH:mm')} - ${endAt?.format('HH:mm')}, ${endAt?.format('MMM DD')} (${endAt?.format('zZ')})` }
          </DateTimeContainer>
        </StyledLink>
      );
    }
    case WebinarType.OnDemand:
    default: {
      return (
        <StyledLink to={Routes.webinar}>
          <NameContainer>
            { name }
          </NameContainer>
        </StyledLink>
      );
    }
  }
};

WebinarSearchResultItem.propTypes = {
  type: PropTypes.oneOf(Object.values(WebinarType)),
  name: PropTypes.string.isRequired,
  startAt: PropTypes.shape(),
  endAt: PropTypes.string,
  timezone: PropTypes.string,
};

WebinarSearchResultItem.defaultProps = {
  startAt: undefined,
  endAt: undefined,
  timezone: undefined,
};

export default WebinarSearchResultItem;
